module.exports = __webpack_public_path__ + "static/media/signaporeBusiness.d5221ee7.png";